{
  "healthway": {
    "title": "AQMS & Speed Control"
  }
}
